var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('Banner_Component'),_c('Server_Component'),_c('AboutUs_Component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }